import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring, AnimatePresence } from 'framer-motion';
export function Cursor() {
  const [enabled, setEnabled] = useState(false);
  const [hoveringInteractive, setHoveringInteractive] = useState(false);
  const [pings, setPings] = useState<{
    id: number;
    x: number;
    y: number;
  }[]>([]);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const springX = useSpring(x, {
    stiffness: 500,
    damping: 40
  });
  const springY = useSpring(y, {
    stiffness: 500,
    damping: 40
  });
  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    setEnabled(true);
    document.documentElement.classList.add('custom-cursor');
    const onMove = (e: MouseEvent) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const target = e.target as HTMLElement;
      setHoveringInteractive(!!target.closest('a, button, [role="button"], input, summary'));
    };
    const onClick = (e: MouseEvent) => {
      const id = Date.now();
      setPings(p => [...p.slice(-4), {
        id,
        x: e.clientX,
        y: e.clientY
      }]);
    };
    window.addEventListener('mousemove', onMove, {
      passive: true
    });
    window.addEventListener('mousedown', onClick);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mousedown', onClick);
      document.documentElement.classList.remove('custom-cursor');
    };
  }, [x, y]);
  if (!enabled) return null;
  return <div className="pointer-events-none fixed inset-0 z-[100]" aria-hidden="true" data-id="element-89">
      {/* Dot */}
      <motion.div className="absolute h-1.5 w-1.5 rounded-full bg-teal-600" style={{
      x,
      y,
      translateX: '-50%',
      translateY: '-50%'
    }} data-id="element-90" />
      {/* Ring */}
      <motion.div className="absolute rounded-full border border-teal-600/50" style={{
      x: springX,
      y: springY,
      translateX: '-50%',
      translateY: '-50%'
    }} animate={{
      width: hoveringInteractive ? 36 : 22,
      height: hoveringInteractive ? 36 : 22,
      opacity: hoveringInteractive ? 0.8 : 0.45
    }} transition={{
      duration: 0.25
    }} data-id="element-91" />
      {/* Sonar pings on click */}
      <AnimatePresence data-id="element-92">
        {pings.map(p => <motion.div key={p.id} className="absolute rounded-full border border-teal-600" style={{
        left: p.x,
        top: p.y,
        translateX: '-50%',
        translateY: '-50%'
      }} initial={{
        width: 10,
        height: 10,
        opacity: 0.45
      }} animate={{
        width: 64,
        height: 64,
        opacity: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} onAnimationComplete={() => setPings(prev => prev.filter(q => q.id !== p.id))} data-id="element-93" />)}
      </AnimatePresence>
    </div>;
}